export const versionCode = "1.0.0" 

export const coockiePrefix = "s-"

// export const baseUrl = "http://localhost:8090/"
export const baseUrl = "https://weconsole.ir/api/wpd-1.0.0/"
